export const STITCH_SERVICES = [
  {
    id: "service-1",
    tierId: "tier-1",
    tierName: "Tier I: Healthcare ADR",
    title: "Frontline & Management Conflict Resolution",
    subtitle: "Neutral, structured mediation resolving operational friction between multidisciplinary teams and management",
    category: "Dispute Resolution Protocol",
    icon: "balance",
    heroImg: "/images/stitch/frontline-conflict.jpg",
    audience: "Chief Nursing Officers, Department Chairs, Nurse Managers, Hospital Directors",
    accreditation: "Privileged Mediation Protocol, Joint Commission HR Standard Compliance",
    timeline: "4 to 8 Weeks Clinical Sprint",
    statBadge: "Substantial voluntary clinical turnover reduction",
    metrics: {
      m1: { label: "Retention Impact", val: "Substantial", sub: "Voluntary turnover mitigation" },
      m2: { label: "Resolution Cycle", val: "Rapid Cycle", sub: "Screening to covenant" },
      m3: { label: "Privileged Status", val: "Zero", sub: "Escalated formal litigations" }
    },
    outcomes: [
      { stat: "Substantial Reduction", desc: "In voluntary clinical nurse and mid-level provider turnover" },
      { stat: "Consensus Avoidance", desc: "Of escalation to formal union arbitration or litigation" },
      { stat: "Rapid Cycle", desc: "Average time to resolution from initial privileged screening" },
      { stat: "Validated Alignment", desc: "Re-established trust metrics via anonymous clinical survey" }
    ],
    scenario: "A 480 bed regional acute care hospital experienced acute friction between the emergency medicine physician group and surgical triage nursing leadership over admission throughput protocols. NFBG Scorpio conducted dual track private caucus mediation, identifying operational resource bottlenecks and drafting a signed joint clinical compact within 21 days."
  },
  {
    id: "service-2",
    tierId: "tier-1",
    tierName: "Tier I: Healthcare ADR",
    title: "Executive & Physician Mediation Services",
    subtitle: "High stakes dispute de escalation for surgical chairs, CMOs, and health system boards under statutory privilege",
    category: "Privileged Dispute Resolution",
    icon: "lock",
    heroImg: "/images/stitch/executive-mediation.jpg",
    audience: "Chief Executive Officers, Board Chairs, Chief Medical Officers, Surgical Department Heads",
    accreditation: "Statutory Peer Review Protections, ADR Certified Mediators",
    timeline: "3 to 6 Weeks Intensive Mediation",
    statBadge: "Preserved high volume surgical contracts",
    metrics: {
      m1: { label: "Contract Preserved", val: "Multi Million", sub: "Annual surgical revenue retained" },
      m2: { label: "External Leaks", val: "Zero", sub: "Statutory confidential covenant" },
      m3: { label: "Bilateral Buy in", val: "Consensus", sub: "Signed OR allocation charter" }
    },
    outcomes: [
      { stat: "Zero Grievances", desc: "Resolved without external regulatory complaints or public leaks" },
      { stat: "Preserved Contracts", desc: "Retained high earning specialty physician group contracts" },
      { stat: "Strictly Confidential", desc: "Guaranteed absolute nondisclosure under peer review statues" },
      { stat: "Realigned Governance", desc: "Unified C-suite and medical executive committee voting blocks" }
    ],
    scenario: "Following an acrimonious restructuring of operating room block time allocations, two senior surgical department heads and the Chief Medical Officer were locked in an impasse threatening surgical volume. Scorpio facilitated confidential bilateral hearings, delivering an equitable block allocation formula signed by all clinical stakeholders."
  },
  {
    id: "service-3",
    tierId: "tier-1",
    tierName: "Tier I: Healthcare ADR",
    title: "Respectful Workplace & Civility Culture",
    subtitle: "System wide restorative justice and psychological safety protocols aligning hospital staff and physician compacts",
    category: "Culture Governance",
    icon: "handshake",
    heroImg: "/images/stitch/civility-culture.jpg",
    audience: "Chief People Officers, Compliance Officers, Medical Staff Executives, Board of Directors",
    accreditation: "Restorative Justice in Healthcare Certified, Joint Commission Civility Standards",
    timeline: "3 to 6 Month System Wide Culture Rollout",
    statBadge: "Dramatic drop in disruptive complaints",
    metrics: {
      m1: { label: "Grievance Mitigation", val: "Significant", sub: "Disruptive conduct reports" },
      m2: { label: "Staff Compacts", val: "Consensus", sub: "Interdisciplinary sign off" },
      m3: { label: "Safety Climate", val: "Substantial", sub: "AHRQ culture benchmark jump" }
    },
    outcomes: [
      { stat: "Significant Drop", desc: "In formal disruptive physician and staff behavior complaints" },
      { stat: "Culture Compact", desc: "Full adoption of signed cross functional civility compacts" },
      { stat: "Safety Climate", desc: "Substantial leap in AHRQ Patient Safety Culture Survey benchmarks" },
      { stat: "Safe Reporting", desc: "Trusted peer intervention channels resolving micro conflicts early" }
    ],
    scenario: "Chronic passive aggressive communication and surgical suite outbursts were causing high nurse turnover in a flagship surgical tower. Scorpio facilitated cross hierarchical civility circles, establishing clear ground rules and an active physician peer support intervention protocol."
  },
  {
    id: "service-4",
    tierId: "tier-2",
    tierName: "Tier II: Executive Leadership",
    title: "1-on-1 Executive Coaching Programs",
    subtitle: "Tailored, discreet advisory sessions focused on leadership agility, strategic poise, and medical executive influence",
    category: "Executive Coaching",
    icon: "person_pin",
    heroImg: "/images/stitch/executive-coaching.jpg",
    audience: "Health System CEOs, CFOs, CMOs, Division Chiefs, Senior Health Leaders",
    accreditation: "International Coaching Federation (ICF) Master Standards, Prosci® Certified",
    timeline: "6 Month Bespoke Executive Retainer",
    statBadge: "Elevated strategic poise and clarity",
    metrics: {
      m1: { label: "Leader Evaluation", val: "Elevated", sub: "Strategic clarity elevation" },
      m2: { label: "Burnout Defense", val: "Mitigated", sub: "Cognitive exhaustion metric" },
      m3: { label: "Succession Ready", val: "Tier 1", sub: "Immediate C-suite succession" }
    },
    outcomes: [
      { stat: "Elevated Evaluation", desc: "Reported elevation in strategic clarity and conflict de escalation" },
      { stat: "Personal Resilience", desc: "Documented decreases in clinical executive burnout and cognitive fatigue" },
      { stat: "Enhanced EQ", desc: "360 degree feedback improvement across high stress interactions" },
      { stat: "Succession Ready", desc: "Coachees positioned for immediate C-suite advancement" }
    ],
    scenario: "A highly regarded cardiothoracic surgical chair was experiencing friction with administrative executives during high stakes budget reviews. Scorpio provided biweekly, confidential executive coaching targeting negotiation posture, strategic emotional intelligence, and collaborative persuasion."
  },
  {
    id: "service-5",
    tierId: "tier-2",
    tierName: "Tier II: Executive Leadership",
    title: "Strategic Leadership Development Programs",
    subtitle: "Equipping newly appointed medical directors and nursing executives with enterprise stewardship acumen",
    category: "Leadership Governance",
    icon: "psychology",
    heroImg: "/images/stitch/strategic-leadership.jpg",
    audience: "Newly Appointed Medical Directors, Physician Executives, Health System VPs",
    accreditation: "American College of Healthcare Executives (ACHE) Aligned Framework",
    timeline: "6 to 12 Month Modular Program",
    statBadge: "Accelerated cross departmental buy in velocity",
    metrics: {
      m1: { label: "Execution Uplift", val: "Accelerated", sub: "Strategic cross team velocity" },
      m2: { label: "Leadership Retention", val: "High Rate", sub: "First 24 month physician benchmark" },
      m3: { label: "P&L Stewardship", val: "Full P&L", sub: "Service line budget mastery" }
    },
    outcomes: [
      { stat: "Accelerated Uplift", desc: "In strategic initiative execution and cross departmental buy in" },
      { stat: "High Retention", desc: "Of newly appointed physician leaders through their first 24 months" },
      { stat: "Financial Acumen", desc: "Direct training in service line P&L stewardship and capital planning" },
      { stat: "Executive Poise", desc: "Confidence managing board presentations and system wide messaging" }
    ],
    scenario: "An expanding multispecialty health system promoted 12 top tier clinicians into executive medical director positions. Scorpio deployed a cohort based executive curriculum covering clinical enterprise governance, conflict triage, and capital budget stewardship."
  },
  {
    id: "service-6",
    tierId: "tier-2",
    tierName: "Tier II: Executive Leadership",
    title: "Leadership in High Pressure Environments",
    subtitle: "Cognitive load mastery and high stress communication training for ER directors, trauma leads, and ICU heads",
    category: "Clinical Governance",
    icon: "emergency",
    heroImg: "/images/stitch/high-pressure-leadership.jpg",
    audience: "Trauma Directors, Emergency Medicine Leads, Critical Care & ICU Chairs",
    accreditation: "High Reliability Organization (HRO) Principles Aligned",
    timeline: "4 to 8 Week Intensive Workshop & Real Time Simulation",
    statBadge: "Accelerated critical decision velocity",
    metrics: {
      m1: { label: "Decision Velocity", val: "Accelerated", sub: "Crisis response speed" },
      m2: { label: "Error Reporting", val: "Substantial", sub: "Psychological safety jump" },
      m3: { label: "HRO Adherence", val: "Grade A", sub: "Joint Commission High Reliability" }
    },
    outcomes: [
      { stat: "Accelerated Speed", desc: "Crisis decision velocity with measurable reductions in team confusion" },
      { stat: "Psychological Safety", desc: "Clear protocols for immediate error reporting without fear of reprisal" },
      { stat: "Burnout Defense", desc: "Practical cognitive decompression habits preventing secondary traumatic stress" },
      { stat: "HRO Adherence", desc: "Complete alignment with High Reliability Organization operating tenants" }
    ],
    scenario: "During a severe hospital surge that strained acute bed capacity, Scorpio deployed a rapid crisis leadership sprint for Level 1 Trauma leadership, focusing on cognitive load preservation, rapid debrief protocols, and team psychological safety."
  },
  {
    id: "service-7",
    tierId: "tier-3",
    tierName: "Tier III: Transformation & Talent",
    title: "Prosci® ADKAR® Change Management",
    subtitle: "Structured methodologies driving adoption during EHR conversions, clinical mergers, and service line reallocations",
    category: "Change Governance",
    icon: "schema",
    heroImg: "/images/stitch/prosci-change.jpg",
    audience: "Chief Transformation Officers, VP of Clinical Operations, IT Executives, PMO Directors",
    accreditation: "Prosci® Certified Change Practitioner, ADKAR® Methodology Certified",
    timeline: "Project Based Transformation Lifecycle",
    statBadge: "High clinician adoption rate in 60 days",
    metrics: {
      m1: { label: "Adoption Rate", val: "High Rate", sub: "Workflow adherence at 60 days" },
      m2: { label: "Milestone Speed", val: "Accelerated", sub: "Schedule lag reduction" },
      m3: { label: "ADKAR Adherence", val: "Score 4.8", sub: "Awareness to Reinforcement" }
    },
    outcomes: [
      { stat: "High Adoption Rate", desc: "Full workflow compliance across medical staff within 60 days of go-live" },
      { stat: "Zero Strike Risk", desc: "Proactive clinician sentiment containment during major contract shifts" },
      { stat: "ADKAR Alignment", desc: "Structured measurement from initial Awareness through Reinforcement" },
      { stat: "Reduced Delay", desc: "Eliminated costly change resistance delays in multisite technology rollouts" }
    ],
    scenario: "A three hospital health system was encountering severe clinical resistance to a centralized Epic EHR and computerized physician order entry rollout. Utilizing the Prosci ADKAR framework, Scorpio diagnosed root resistance triggers and built targeted sponsor roadmaps."
  },
  {
    id: "service-8",
    tierId: "tier-3",
    tierName: "Tier III: Transformation & Talent",
    title: "Hiring Right from the Start for Managers",
    subtitle: "Behavioral assessment protocols tailored for clinical department chiefs to prevent high friction mismatches",
    category: "Talent Architecture",
    icon: "groups",
    heroImg: "/images/stitch/hiring-right.jpg",
    audience: "Clinic Managers, Clinical Nurse Managers, HR Business Partners, Operations Directors",
    accreditation: "Evidence Based Structured Behavioral Interviewing Standards",
    timeline: "2 to 4 Week Department Implementation",
    statBadge: "Marked drop in 90 day staff turnover",
    metrics: {
      m1: { label: "90-Day Turnover", val: "Marked Drop", sub: "Healthcare staff retention" },
      m2: { label: "Time-to-Hire", val: "38 Days", sub: "Standardized panel sprint" },
      m3: { label: "Leader Hours Saved", val: "40 hrs", sub: "Streamlined interview matrix" }
    },
    outcomes: [
      { stat: "Marked Reduction", desc: "In 90 day healthcare staff turnover across pilot departments" },
      { stat: "Objective Scoring", desc: "Elimination of intuitive bias via rubric based competency grids" },
      { stat: "Cultural Fit", desc: "Explicit vetting for stress resilience, civility, and clinical empathy" },
      { stat: "Speed to Quality", desc: "Streamlined multistakeholder panel interviews saving 40 leadership hours" }
    ],
    scenario: "A major outpatient ambulatory network was suffering from chronic turnover among clinic supervisors and nursing managers. Scorpio implemented an end to end selection matrix emphasizing emotional stamina and de escalation capability."
  }
];

export const STITCH_TIERS = {
  "tier-1": {
    id: "tier-1",
    badge: "TIER I • DISPUTE RESOLUTION",
    title: "Healthcare ADR & Impasse Mediation",
    subtitle: "Resolving High Stakes Friction, Medical Staff & MEC Impasses",
    icon: "balance",
    tabLabel: "Tier I: Healthcare ADR",
    overview: "Privileged neutral caucus, peer review aligned mediation, and restorative civility frameworks resolving operational conflict under statutory privilege. Specifically designed to avert high risk medical litigation, physician group contract cancellations, and toxic department stalemates.",
    pillPractices: [
      "Frontline & Management Conflict Resolution",
      "Executive & Physician Mediation Services",
      "Respectful Workplace & Civility Culture"
    ],
    services: [
      {
        title: "Frontline & Management Conflict Resolution",
        desc: "Structured de escalation for nursing managers, department heads, and multidisciplinary units facing systemic workflow friction.",
        tag: "Operational Alignment"
      },
      {
        title: "Executive & Physician Mediation Services",
        desc: "Confidential dispute resolution protecting high revenue surgical blocks, MEC disagreements, and C suite physician conflicts.",
        tag: "Statutory Peer Review"
      },
      {
        title: "Respectful Workplace & Civility Culture",
        desc: "System wide restorative covenants replacing disruptive grievance cultures with psychological safety and shared accountability.",
        tag: "Joint Commission Aligned"
      }
    ],
    metrics: [
      { label: "Mediation Retention", val: "High Rate", sub: "Physicians preserved in system post resolution" },
      { label: "Turnover Mitigation", val: "Substantial", sub: "Decrease in voluntary clinical departures" },
      { label: "Speed to Resolution", val: "Rapid Cycle", sub: "From initial screening to signed compact" }
    ]
  },
  "tier-2": {
    id: "tier-2",
    badge: "TIER II • EXECUTIVE LEADERSHIP",
    title: "Physician Executive & Leadership Advisory",
    subtitle: "Cultivating High Stamina Clinical Enterprise Leaders",
    icon: "psychology",
    tabLabel: "Tier II: Executive Leadership",
    overview: "Bespoke executive development, 1-on-1 confidential coaching, and crisis decision frameworks tailored for Chief Medical Officers, Service Line Chairs, and Health System VPs moving from clinical excellence to enterprise stewardship.",
    pillPractices: [
      "1-on-1 Executive Coaching Programs",
      "Strategic Leadership Development Programs",
      "Leadership in High Pressure Environments"
    ],
    services: [
      {
        title: "1-on-1 Executive Coaching Programs",
        desc: "Discreet confidential coaching targeting strategic poise, board influence, and negotiation endurance in high stress hospital governance.",
        tag: "ICF Master Standards"
      },
      {
        title: "Strategic Leadership Development Programs",
        desc: "Cohort curriculum for newly appointed physician chairs mastering service line P&L stewardship and multi stakeholder diplomacy.",
        tag: "ACHE Aligned"
      },
      {
        title: "Leadership in High Pressure Environments",
        desc: "Cognitive load preservation, crisis response velocity, and psychological safety mastery for Trauma, ICU, and Emergency directors.",
        tag: "High Reliability (HRO)"
      }
    ],
    metrics: [
      { label: "Strategic Poise", val: "Elevated", sub: "Reported executive clarity elevation" },
      { label: "Buy in Velocity", val: "Accelerated", sub: "Cross departmental initiative execution" },
      { label: "Burnout Defense", val: "Mitigated", sub: "Reduction in senior leader cognitive fatigue" }
    ]
  },
  "tier-3": {
    id: "tier-3",
    badge: "TIER III • TRANSFORMATION & TALENT",
    title: "Transformation, Change & Talent Governance",
    subtitle: "Institutional Stability, Seamless Adoption & Cultural Resilience",
    icon: "schema",
    tabLabel: "Tier III: Transformation & Talent",
    overview: "Certified Prosci® ADKAR® change management frameworks, behavioral hiring matrices, and clinical alignment methodologies ensuring major EHR transitions, mergers, and institutional restructurings stick without alienating medical staff.",
    pillPractices: [
      "Prosci® ADKAR® Change Management",
      "Hiring Right from the Start for Managers"
    ],
    services: [
      {
        title: "Prosci® ADKAR® Change Management",
        desc: "Structured change governance eliminating physician resistance during major clinical rollouts and health system consolidations.",
        tag: "Certified Prosci® ADKAR®"
      },
      {
        title: "Hiring Right from the Start for Managers",
        desc: "Evidence based behavioral interviewing rubrics screening for emotional resilience and cultural fit before clinical offers are extended.",
        tag: "Competency Matrix"
      }
    ],
    metrics: [
      { label: "Clinician Adoption", val: "High Rate", sub: "Workflow adherence across active staff" },
      { label: "Manager Retention", val: "Elevated", sub: "Improvement across newly onboarded managers" },
      { label: "Implementation Lag", val: "Minimized", sub: "Elimination of digital change resistance delays" }
    ]
  }
};

export const ENGAGEMENT_PHASES = [
  {
    phase: "Phase 01",
    title: "Privileged Assessment",
    desc: "Confidential individual discovery interviews and objective institutional diagnostic."
  },
  {
    phase: "Phase 02",
    title: "Neutral Mediation",
    desc: "Facilitated dispute de-escalation and root cause negotiation sessions."
  },
  {
    phase: "Phase 03",
    title: "Strategic Synthesis",
    desc: "Actionable leadership covenants, role realignment, and operational compacts."
  },
  {
    phase: "Phase 04",
    title: "Governance Review",
    desc: "Quarterly adherence checkpoints ensuring permanent behavioral stability."
  }
];

export const CORE_DIFFERENTIATORS = [
  {
    icon: "local_hospital",
    colorClass: "bg-primary/10 text-primary",
    title: "Healthcare Exclusive Focus",
    desc: "Unlike general corporate consultancies, our methodologies are calibrated expressly for medical staff bylaws, peer review, and clinical operational complexity."
  },
  {
    icon: "verified_user",
    colorClass: "bg-accent-teal/10 text-accent-teal",
    title: "Privileged & Confidential",
    desc: "Ironclad statutory protections protect institutional prestige, board proceedings, and medical leadership confidentiality under statutory peer review provisions."
  },
  {
    icon: "analytics",
    colorClass: "bg-secondary/10 text-secondary",
    title: "Evidence Based Clinical ROI",
    desc: "Demonstrated impact: Substantial clinical retention gains, accelerated mediation velocity, and marked reductions in disruptive grievances."
  }
];

export const PRACTICE_CATEGORIES = [
  {
    category: "Tier I: Healthcare ADR & Impasse Mediation",
    shortName: "Tier I: Dispute Resolution",
    services: [
      "Frontline & Management Conflict Resolution",
      "Executive & Physician Mediation Services",
      "Respectful Workplace & Civility Culture"
    ]
  },
  {
    category: "Tier II: Physician Executive & Leadership Advisory",
    shortName: "Tier II: Executive Leadership",
    services: [
      "1-on-1 Executive Coaching Programs",
      "Strategic Leadership Development Programs",
      "Leadership in High Pressure Environments"
    ]
  },
  {
    category: "Tier III: Transformation, Change & Talent Governance",
    shortName: "Tier III: Transformation & Talent",
    services: [
      "Prosci® ADKAR® Change Management",
      "Hiring Right from the Start for Managers"
    ]
  },
  {
    category: "Emergency Privileged Mediation Retainer",
    shortName: "Emergency Retainer",
    services: []
  },
  {
    category: "General Confidential Consultation",
    shortName: "General Consultation",
    services: []
  }
];

export const mapServiceToCategoryAndService = (query) => {
  if (!query || typeof query !== "string") return { category: "", service: "" };
  const qLower = query.toLowerCase().trim();

  // 1. Direct match with specific services across all categories
  for (const cat of PRACTICE_CATEGORIES) {
    const directMatch = cat.services.find(
      (s) => s.toLowerCase() === qLower || s.toLowerCase().includes(qLower) || qLower.includes(s.toLowerCase())
    );
    if (directMatch) {
      return { category: cat.category, service: directMatch };
    }
  }

  // 2. Keyword fallback for strategic tiers or retainers
  if (qLower.includes("tier i") || qLower.includes("tier 1") || qLower.includes("adr") || qLower.includes("impasse") || qLower.includes("mediation")) {
    return {
      category: "Tier I: Healthcare ADR & Impasse Mediation",
      service: ""
    };
  }
  if (qLower.includes("tier ii") || qLower.includes("tier 2") || qLower.includes("physician executive") || qLower.includes("coaching") || qLower.includes("leadership")) {
    return {
      category: "Tier II: Physician Executive & Leadership Advisory",
      service: ""
    };
  }
  if (qLower.includes("tier iii") || qLower.includes("tier 3") || qLower.includes("transformation") || qLower.includes("talent") || qLower.includes("change")) {
    return {
      category: "Tier III: Transformation, Change & Talent Governance",
      service: ""
    };
  }
  if (qLower.includes("retainer") || qLower.includes("crisis") || qLower.includes("emergency")) {
    return {
      category: "Emergency Privileged Mediation Retainer",
      service: ""
    };
  }

  return {
    category: "General Confidential Consultation",
    service: ""
  };
};

